import { tailwindSheet, baseStyles } from '../../../_shared/styles.js';

const sheet = new CSSStyleSheet();
sheet.replaceSync(`
    :host {
        display: contents;
    }
`);

export default [tailwindSheet, baseStyles, sheet];
